module.exports = __webpack_public_path__ + "img/remove-watchlist.081abb03.svg";